import React from 'react';
import { Oval } from "react-loader-spinner";

interface FullPageLoaderProps {
    color?: string;
    loading?: boolean;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ color = "#f86400", loading = true }) => {
    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <span style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
                <Oval
                    visible={true}
                    height="45"
                    width="45"
                    color={color}
                    secondaryColor='#fff'
                    strokeWidth={5}
                    strokeWidthSecondary={5}
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </span>
        </div>
    );
};

export default FullPageLoader;
